<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="brokersLimit"
				textCreate="Add broker"
				flag="brokers"
				page-title="Brokers"
				:headers="headers"
				:settings="getSettings"
				:filtersList="brokersFilters"
				:list="brokersList"
				:defaultOrder="brokersOrder"
				:defaultSort="brokersSort"

				:totals="brokersTotals"
				:total-pages="brokersTotal"
				:limit-pages="brokersLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				is-settings
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('broker')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>

		<brokers-form
				v-if="isBrokersForm"
				:brokerId="brokerId"
				:brokersItem="brokersItem"
				@updateClose="onCloseDialog"
		></brokers-form>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import BrokersForm from "@/components/Maintenance/Brokers/BrokersForm";
// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "Brokers",
	mixins: [ settingsMixins, removeMixins ],
	components: { MainTableAllBack, BrokersForm },
	computed: mapGetters([
		"brokersList",
		"brokersFilters",
		"brokersTotals",
		"permissions",
		"brokersOrder",
		"brokersLimit",
		"brokersSort",
		"brokersTotal",
		"brokersItem",
		"previewLink",
	]),
	data: () => ({
		isCommentsPopup: false,
		isBrokersForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		brokerId: null,
	}),
	methods: {
		...mapActions([
			'getBrokers',
			'getBrokersFilters',
			'actionPreloader',
			'onExportLink',
			'onBrokersRemoveItem'
		]),
		onCloseDialog(isRefresh) {
			this.isBrokersForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},
		async onRemoveItem() {
			const { status } = await this.onBrokersRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			await this.onUpdateFilters(this.defaultFilter);
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isBrokersForm = true;
				this.brokerId = null;
			}
		},

		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getBrokers(filters);
			if (!isWithoutFilters) await this.getBrokersFilters(filters);
		},

		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getBrokers(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'brokers' });
		},
		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.brokerId = item.broker_id;
					this.isBrokersForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.broker_id);
				}
			}
		},
		onEdit({ line }) {  
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.brokerId = line.broker_id;
				this.isBrokersForm = true;
			}
		},
	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>
